import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import { Link, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getfeetype, updatestandardfees, getstandardfees } from "../../store/slices/fees";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import {
    FiHome,
    FiChevronRight,
} from "react-icons/fi";

export default function EditFees() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        standard: "",
        session: "",
        feeCategory: "",
        totalAmount: "",
        terms: [{ term: "", amount: "" }],
    });

    const [errors, setErrors] = useState({});

    const { feestype = [], feeslist = [] } = useSelector((state) => state.fees || {});


    const { classsectionList = [] } = useSelector((state) => state.classsection || {});

    useEffect(() => {
        dispatch(getfeetype());
        dispatch(fetchStandardSection());
    }, dispatch)


    // sent id , get matched data
    useEffect(() => {
        if (id) {
            dispatch(getstandardfees({ id }))
                .unwrap()
                .then((res) => {
                    const feesData = res?.data?.[0];

                    if (feesData) {
                        const feeDetail = feesData.feeDetails?.[0];

                        setFormData({
                            standard: feesData.standardId?._id || "",
                            session: feesData.session || "",
                            feeCategory: feeDetail?.feeCategoryId?._id || "",
                            totalAmount: feeDetail?.amount || "",
                            terms:
                                feeDetail?.paymentBreakdown?.length > 0
                                    ? feeDetail.paymentBreakdown.map((t) => ({
                                        term: t.name || "",
                                        amount: t.amount || "",
                                    }))
                                    : [{ term: "", amount: "" }],
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    toast.error(
                        err?.response?.data?.message ||
                        err?.message ||
                        "Failed to fetch fee details"
                    );
                });
        }
    }, [id, dispatch]);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };


    const handleTermChange = (index, field, value) => {
        const updatedTerms = [...formData.terms];
        updatedTerms[index][field] = value;
        setFormData({ ...formData, terms: updatedTerms });
    };

    const addTerm = () => {
        if (formData.terms.length < 5) {
            setFormData({
                ...formData,
                terms: [...formData.terms, { term: "", amount: "" }],
            });
        } else {
            toast.error("You can only add a maximum of 5 terms.")
        }
    };


    const removeTerm = (index) => {
        const updatedTerms = formData.terms.filter((_, i) => i !== index);
        setFormData({ ...formData, terms: updatedTerms });
    };

    /* ---------- validation ---------- */
    const validate = () => {
        let newErrors = {};

        if (!formData.standard) newErrors.standard = "Select Standard";
        if (!formData.session) newErrors.session = " Select Session";
        if (!formData.feeCategory)
            newErrors.feeCategory = " Select Fees category ";
        if (!formData.totalAmount)
            newErrors.totalAmount = "Enter Total amount";

        formData.terms.forEach((t, index) => {
            if (!t.term)
                newErrors[`term_${index}`] = "Enter term ";
            if (!t.amount)
                newErrors[`amount_${index}`] = "Enter term amount";
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /* submit ---------- */
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;

        const payload = {
            id,
            session: formData.session,
            standardId: formData.standard,
            feeDetails: [
                {
                    feeCategoryId: formData.feeCategory,
                    amount: Number(formData.totalAmount),
                    paymentBreakdown: formData.terms.map(item => ({
                        name: item.term,
                        amount: Number(item.amount)
                    }))
                }
            ],
        }
        dispatch(updatestandardfees(payload))
            .unwrap()
            .then(() => {
                toast.success("fees added successfully");
                navigate("/institute/fees");
            })
            .catch((err) => {
                toast.error(err.message || "Failed to add fees");
            });
    };

    return (
        <>
            <div className="page-header">
                <div className="breadcrumb-section">

                    <div className="breadcrumb-left">
                        <div className="home-icon">
                            <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
                        </div>

                        <FiChevronRight className="separator" />

                        <Link to="/institute/fees">Fees</Link>

                        <FiChevronRight className="separator" />

                        <span className="active">Edit Fees</span>
                    </div>

                </div>
            </div>

            <div className="acs-card">
                <Form onSubmit={handleSubmit}>

                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Label>Standard</Form.Label>
                            <Form.Select
                                name="standard"
                                value={formData.standard}
                                onChange={handleChange}
                                isInvalid={!!errors.standard}
                                disabled
                            >
                                <option value="">Select Standard</option>
                                {classsectionList?.map((item) => (
                                    <option key={item.standardId?._id} value={item.standardId?._id}>
                                        {item.standardId.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.standard}
                            </Form.Control.Feedback>
                        </Col>

                        <Col md={3}>
                            <Form.Label>Session</Form.Label>
                            <Form.Select
                                type="text"
                                placeholder="2025-2026"
                                name="session"
                                value={formData.session}
                                onChange={handleChange}
                                isInvalid={!!errors.session}
                            >
                                <option value="">Select session</option>
                                <option value="2025-2026">2025-2026</option>
                                <option value="2024-2025">2024-2025</option>
                                <option value="2023-2024">2023-2024</option>
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {errors.session}
                            </Form.Control.Feedback>
                        </Col>

                        <Col md={3}>
                            <Form.Label>Fee Category</Form.Label>
                            <Form.Select
                                type="text"
                                placeholder="Tuition Fee"
                                name="feeCategory"
                                value={formData.feeCategory}
                                onChange={handleChange}
                                isInvalid={!!errors.feeCategory}
                            >
                                <option value="">Fee Category</option>
                                {feestype.map((item) => (
                                    <option key={item?._id} value={item?._id}>
                                        {item?.name}
                                    </option>
                                ))}

                            </Form.Select>

                            <Form.Control.Feedback type="invalid">
                                {errors.feeCategory}
                            </Form.Control.Feedback>
                        </Col>

                        <Col md={6}>
                            <Form.Label>Total Amount</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder=" Total amount"
                                name="totalAmount"
                                value={formData.totalAmount}
                                onChange={handleChange}
                                isInvalid={!!errors.totalAmount}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors.totalAmount}
                            </Form.Control.Feedback>
                        </Col>
                    </Row>


                    <h6 className="mb-2">Term Breakdown</h6>

                    {formData.terms.map((t, index) => (
                        <Row key={index} className="align-items-center mb-2">
                            <Col md={5}>
                                <Form.Control
                                    placeholder="Term name (e.g. Term-1)"
                                    value={t.term}
                                    onChange={(e) =>
                                        handleTermChange(index, "term", e.target.value)
                                    }
                                    isInvalid={!!errors[`term_${index}`]}
                                />
                            </Col>

                            <Col md={5}>
                                <Form.Control
                                    type="text"
                                    placeholder="Amount"
                                    value={t.amount}
                                    onChange={(e) =>
                                        handleTermChange(index, "amount", e.target.value)
                                    }
                                    isInvalid={!!errors[`amount_${index}`]}
                                />
                            </Col>

                            <Col md={2} className="d-flex gap-2">
                                <Button
                                    variant="outline-primary"
                                    onClick={addTerm}
                                    type="button"
                                >
                                    <FiPlus />
                                </Button>

                                {formData.terms.length > 1 && (
                                    <Button
                                        variant="outline-danger"
                                        onClick={() => removeTerm(index)}
                                        type="button"
                                    >
                                        <FiTrash2 />
                                    </Button>
                                )}
                            </Col>
                        </Row>
                    ))}
                    <div className="form-actions">
                        <button
                            type="button"
                            className="btn-cancel"
                            onClick={() => navigate(-1)}
                        >
                            Cancel
                        </button>
                        <button type="submit" className="btn-submit">
                            Update
                        </button>
                    </div>
                </Form>
            </div>

        </>
    );
}
